import {
  AwesomeTableComponent,
  Button,
  InputTextSearch,
  Notifications,
  Progress,
} from "d-react-components";
import { debounce, map } from "lodash";
import React, { useContext, useRef, useState } from "react";
import WarehouseDetailChannelUpdateDrawer from "./WarehouseDetailChannelUpdateDrawer";
import AppContext from "@helpers/context";
import WarehouseAPI from "@network/api/warehouse";
import { useTranslation } from "react-i18next";

const WarehouseDetailChannel = () => {
  const { warehouse, loadWarehouseDetail } = useContext(AppContext);
  const [openAdd, setOpenAdd] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);
  const { t } = useTranslation();
  const textSearch = useRef("");

  const columns = [
    {
      title: t("NO"),
      dataIndex: "",
      render: (value: any, item: any, index: any) => index + 1,
    },
    {
      title: t("name"),
      dataIndex: "name",
      render: (name: string, channel: any) => (
        <a href={channel?.editurl} target="_blank" rel="noreferrer">
          {name}
        </a>
      ),
    },
    {
      title: t("code"),
      dataIndex: "code",
    },
  ];

  const tableRef = useRef<any>();

  const source = () => {
    const body = {
      action: "in",
      id: warehouse?.id,
      search: textSearch.current,
    };
    return WarehouseAPI.channelList(body);
  };

  const transformer = (res: any) => {
    return res?.data?.data?.channel ?? [];
  };

  const onAddChannel = (channels: any) => {
    const body = {
      id: warehouse?.id,
      action: "add",
      channel: map(channels, (item) => item.id),
    };
    Progress.show(
      { method: WarehouseAPI.channelUpdate, params: [body] },
      () => {
        setOpenAdd(false);
        tableRef.current.refresh();
        Notifications.showSuccess(t("updateWarehouseSuccess"));
      }
    );
  };

  const onRemoveChannel = (channels: any) => {
    const body = {
      id: warehouse?.id,
      action: "remove",
      channel: map(channels, (item) => item.id),
    };
    Progress.show(
      { method: WarehouseAPI.channelUpdate, params: [body] },
      () => {
        setOpenRemove(false);
        tableRef.current.refresh();
        Notifications.showSuccess(t("updateWarehouseSuccess"));
      }
    );
  };

  const onChangeTextSearch = debounce((text) => {
    textSearch.current = text;
    tableRef.current.refresh();
  }, 300);

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center">
        <InputTextSearch
          placeholder={t("search")}
          onChange={(e: any) => onChangeTextSearch(e.target.value)}
        />
        <div className="d-flex">
          <Button onClick={() => setOpenRemove(true)} className="ml-2">
            {t("remove")}
          </Button>
          <Button onClick={() => setOpenAdd(true)} className="ml-2">
            {t("add")}
          </Button>
        </div>
      </div>
      <AwesomeTableComponent
        ref={(ref) => {
          tableRef.current = ref;
        }}
        columns={columns}
        source={source}
        transformer={transformer}
        className="mt-3"
      />
      {openAdd && (
        <WarehouseDetailChannelUpdateDrawer
          open={openAdd}
          onClose={() => setOpenAdd(false)}
          warehouseId={warehouse?.id}
          onSave={onAddChannel}
          title={t("addChannel")}
          type="not_in"
        />
      )}
      {openRemove && (
        <WarehouseDetailChannelUpdateDrawer
          open={openRemove}
          onClose={() => setOpenRemove(false)}
          warehouseId={warehouse?.id}
          onSave={onRemoveChannel}
          title={t("removeChannel")}
          type="in"
        />
      )}
    </div>
  );
};

export default WarehouseDetailChannel;
